import * as ComponentConstants from "../constants/ComponentConstants";
import * as DomainConstants from "../constants/DomainConstants";

export default {
	// initiële state bij het starten van de app.
	// Evt defaults in opnemen
	ajaxCounter: 0,
	exception: {
		exception: null,
		redirectToExceptionPage: false
	},
	settings: {
		apiRoot: '', // root to the shared apis, including /api
		siteRoot: '', // root to the portal
		subsidiesWebAppRoot: '', // root to the parent subsidies app
		helpdeskContactLink: "",
		sportDBUrl: '',
		fileTypes: {},
		maxAllowedContentLength: "",
		accountId: "",
		accountType: "",
		disabled: false,
		environment: "",
		sportVlaanderenRoot: "",
		spakkiBevragingstoolUrl: ""
	},
	session: {
		organisaties: [],
		activeOrganisatieOndernemingsnummer: null,
		activeOrganisatieNaam: "",
		activeOrganisatieId: null,
		emailAdres: null,
		gebruikersnaam: null,
		readOnly: false,
		isNew: false,
		activeSportclubId: null,
		activeTransactionId: null,
		sportclubSearchModel: {},
		hasUnsavedChanges: false,
		activateSportorganisatiePopupShown: false,
		userType: DomainConstants.UserTypes.DEFAULT,
		activeOrganisatieNiveau: null
	},
	security: {
		currentUser: "",
		currentApplication: "",
		currentOrganisationInfo: {},
		organisations: [],
		Roles: {}
	},
	validatieStatussen: [],
	layout: {
		pageHeaderTitle: "",
		pageHeaderSubtitle: "",
		activeTopNavItemId: "1",
		showHeader: false,
		showTopNav: false,
		showBeads: false,
		scope: "default",
		topNavTabsSet: false,
		topNavTabSettings: {
			organisatie: { tabNr: 1, text: "Organisatie", color: ComponentConstants.COLOR_BLUE, iconType: ComponentConstants.ICON_ORGANISATIE, disabled: false, visible: true, urlSuffix: "/sportorganisatie/organisatie/", showBead: false, showAsSideNav: false },
			identificatieTab: { tabNr: 2, text: "Identificatie", color: ComponentConstants.COLOR_ORANGE, iconType: ComponentConstants.ICON_IDENTIFICATIE, disabled: false, visible: true, urlSuffix: "/sportorganisatie/identificatie/", showBead: false, showAsSideNav: false },
			sportinfrastructuurTab: { tabNr: 4, text: "Sportinfrastructuur", color: ComponentConstants.COLOR_RED, iconType: ComponentConstants.ICON_SPORTINFRASTRUCTUUR, disabled: false, visible: true, urlSuffix: "/sportorganisatie/sportinfrastructuur/", showBead: false, showAsSideNav: false },
			adresTab: { tabNr: 3, text: "Adres", color: ComponentConstants.COLOR_GREEN_LIGHT, iconType: ComponentConstants.ICON_ADRES, disabled: false, visible: true, urlSuffix: "/sportorganisatie/adres/", showBead: false, showAsSideNav: false },
			sporttakkenTab: { tabNr: 5, text: "Sporttakken", color: ComponentConstants.COLOR_GREEN, iconType: ComponentConstants.ICON_SPORTTAKKEN, disabled: false, visible: true, urlSuffix: "/sportorganisatie/sporttakken/", showBead: false, showAsSideNav: false },
			doelgroepTab: { tabNr: 6, text: "Doelgroep", color: ComponentConstants.COLOR_PINK_LIGHT, iconType: ComponentConstants.ICON_DOELGROEP, disabled: false, visible: true, urlSuffix: "/sportorganisatie/doelgroep/", showBead: false, showAsSideNav: false },
			socialemediaTab: { tabNr: 7, text: "Sociale Media", color: ComponentConstants.COLOR_PURPLE, iconType: ComponentConstants.ICON_SOCIALEMEDIA, disabled: false, visible: true, urlSuffix: "/sportorganisatie/socialemedia/", showBead: false, showAsSideNav: false },
			linksTab: { tabNr: 8, text: "Links", color: ComponentConstants.COLOR_BLUE, iconType: ComponentConstants.ICON_LINKS, disabled: false, visible: true, urlSuffix: "/sportorganisatie/links/", showBead: false, showAsSideNav: false },
			extracommentaarTab: { tabNr: 9, text: "Extra Commentaar", color: ComponentConstants.COLOR_ORANGE, iconType: ComponentConstants.ICON_EXTRACOMMENTAAR, disabled: false, visible: true, urlSuffix: "/sportorganisatie/extracommentaar/", showBead: false, showAsSideNav: false },
			dienInTab: { tabNr: 99, text: "Dien In", color: ComponentConstants.COLOR_WHITE, iconType: ComponentConstants.ICON_DIENIN, disabled: false, visible: true, urlSuffix: "/federatie/overzicht", showBead: false, showAsSideNav: false, backToOverview: true, customNavAction: DomainConstants.CustomNavActions.DIEN_IN },
			naarOverzichtTab: { tabNr: -1, text: "Terug naar overzicht", color: ComponentConstants.COLOR_GREEN_LIGHT, iconType: ComponentConstants.ICON_TERUGNAAROVERZICHT, disabled: false, visible: true, urlSuffix: "/federatie/overzicht", showBead: false, showAsSideNav: false, backToOverview: true }
		},
		topNavPrefix: "",
		showSideNav: false,
		sideNavItems: [], // {id: "1", display: "SideNav Example 1", linkEnabled: true }
		sideNavPrefix: ""
	},
	referentie: {
		statuten: [],
		rechtsvormen: [],
		sporttakken: [],
		locaties: [],
		aarden: [],
		landen: [],
		adresTypes: [],
		gemeenten: [],
		postcodes: [],
		zoekDeelGemeenten: [],
		doelgroepen: [],
		niveauInstanties: [],
		organisatieTypes: [],
		niveausPerOrganisatie: []
	},
	customModal: {
		isOpen: false,
		title: "",
		message: "",
		onCancel: null,
		onConfirm: null,
		handleUnsavedChanges: false
	},
	nieuweSportclubModels: {
		organisatie: {
			naam: null,
			afkorting: null,
			telefoon: null,
			gsm: null,
			email: null,
			website: null,
			extraGegevens: null,
			logo: null,
			documentatie: null
		},
		identificatie: {
			oprichtDatum: null,
			ondernemingsnummer: null,
			rechtsvorm: 2,
			isAangeslotenBijSportfederatie: false,
			naamSportfederatie: null
		},
		adres: {
			adressen: []
		},
		sporttak: {
			sporttakken: []
		},
		doelgroep: {
			doelgroepen: []
		},
		socialeMedia: {
			facebookLink: null,
			linkedInLink: null,
			youTubeLink: null,
			instagramLink: null
		},
		andereOpmerking: {
			opmerking: null
		}
	}
};
